export enum SlicePieceStatus {
	None,
	IsFetching,
	Error,
	Success,
}
